// src/services/auth-service/upstoxService.js
//
// FIXED:
//   - baseURL now points to the ngrok tunnel (where Django actually lives)
//   - login redirect uses the same ngrok URL
//   - FRONTEND_URL on Django must match where React is (http://154.61.75.209:3000)

import axios from 'axios';
import { headers, up_baseUrl_1, baseUrl } from '../common/credentials.js';

// ─────────────────────────────────────────────
//  PORT CONFIG
// ─────────────────────────────────────────────
export const port = "1200";

// ─────────────────────────────────────────────
//  BASE URL
//  up_baseUrl_1 should be your ngrok URL, e.g.:
//  "https://35e8-2404-bd00-4-b000-00-f6.ngrok-free.app"
//
//  In credentials.js set:
//    export const up_baseUrl_1 = "https://35e8-2404-bd00-4-b000-00-f6.ngrok-free.app";
// ─────────────────────────────────────────────
export const UpstoxBase123 = () => {
  const url = `${up_baseUrl_1}/api/v2/user_modules/api/upstox`;
  return [headers, url];
};
export const basedUrl = "http://154.61.75.209:1200";

export const UpstoxBase = () => {
  const url = `${basedUrl}/api/v2/user_modules/api/upstox`;
  return [headers, url];
};
const [, upstoxbaseUrl] = UpstoxBase();

// ─────────────────────────────────────────────
//  AXIOS INSTANCE
//  NOTE: Do NOT set Content-Type in default headers for GET requests —
//  it triggers a CORS preflight that some servers reject.
//  Let axios set it automatically per request.
// ─────────────────────────────────────────────
const ax = axios.create({
  baseURL:         upstoxbaseUrl,
  withCredentials: true,
  headers: {
    // Only pass headers your Django CORS_ALLOW_HEADERS accepts
    // Remove Content-Type from default — axios adds it automatically
    ...Object.fromEntries(
      Object.entries(headers).filter(([k]) =>
        !['content-type', 'Content-Type'].includes(k)
      )
    ),
  },
});

// ─────────────────────────────────────────────
//  ERROR CLASS
// ─────────────────────────────────────────────
export class UpstoxAuthError extends Error {
  constructor(msg) {
    super(msg);
    this.name = 'UpstoxAuthError';
  }
}

// ─────────────────────────────────────────────
//  INTERCEPTOR — convert 401 to UpstoxAuthError
// ─────────────────────────────────────────────
ax.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      return Promise.reject(
        new UpstoxAuthError(err.response.data?.error || 'Upstox session expired')
      );
    }
    return Promise.reject(err);
  }
);

// ─────────────────────────────────────────────
//  URL BUILDERS (kept for your pattern)
// ─────────────────────────────────────────────
export const UpstoxAuthStatus = () => {
  const url = `${upstoxbaseUrl}/auth/status/`;
  return [headers, url];
};

// Login goes to Django directly (browser redirect, not axios)
// Must use the same base as Django is served on
export const UpstoxLoginUrl = () => {
  const url = `${up_baseUrl_1}/api/v2/user_modules/api/upstox/auth/login/`;
  return [headers, url];
};

export const BackTest = () => {
    let url = baseUrl + port + "/api/v2/user_modules/api/upstox/backtest/";
    return ([headers, url]);
}

export const HistoricalDataStoring = () => {
    let url = baseUrl + port + "/api/v2/user_modules/api/upstox/clickhouse/store-historic-data/";
    return ([headers, url]);
}

export const UpstoxLogout = () => {
  const url = `${upstoxbaseUrl}/auth/logout/`;
  return [headers, url];
};

// ─────────────────────────────────────────────
//  AUTH
// ─────────────────────────────────────────────
export const upstoxAuth = {
  status: () =>
    ax.get('/auth/status/').then(r => r.data),

  // Browser redirect — goes to Django login view which redirects to Upstox
  login: () => {
    const [, url] = UpstoxLoginUrl();
    window.location.href = url;
  },

  logout: () =>
    ax.post('/auth/logout/').then(r => r.data),
};

// ─────────────────────────────────────────────
//  MARKET DATA
// ─────────────────────────────────────────────
export const upstoxMarket = {
  ltp: (keys) =>
    ax.get('/market/ltp/', { params: { symbols: keys.join(',') } }).then(r => r.data),

  quote: (keys) =>
    ax.get('/market/quote/', { params: { symbols: keys.join(',') } }).then(r => r.data),

  candles: (symbol, interval, from, to) =>
    ax.get('/market/candles/', { params: { symbol, interval, from, to } }).then(r => r.data),

  intradayCandles: (symbol, interval = '1minute') =>
    ax.get('/market/intraday/', { params: { symbol, interval } }).then(r => r.data),

  optionChain: (symbol, expiry) =>
    ax.get('/market/option-chain/', { params: { symbol, expiry } }).then(r => r.data),

  search: (query, exchange = 'NSE_EQ') =>
    ax.get('/market/search/', { params: { query, exchange } }).then(r => r.data),
};

// ─────────────────────────────────────────────
//  SCREENER
// ─────────────────────────────────────────────
export const upstoxScreener = {
  batchQuotes: (keys) =>
    ax.get('/screener/scan/', { params: { symbols: keys.join(',') } }).then(r => r.data),
};

// ─────────────────────────────────────────────
//  INSTRUMENT KEYS
// ─────────────────────────────────────────────
export const NIFTY50_KEYS = [
  'NSE_EQ|INE002A01018',  // RELIANCE
  'NSE_EQ|INE040A01034',  // HDFCBANK
  'NSE_EQ|INE009A01021',  // INFY
  'NSE_EQ|INE467B01029',  // TCS
  'NSE_EQ|INE062A01020',  // SBIN
  'NSE_EQ|INE155A01022',  // ITC
  'NSE_EQ|INE090A01021',  // ICICIBANK
  'NSE_EQ|INE585B01010',  // AXISBANK
  'NSE_EQ|INE021A01026',  // ASIANPAINT
  'NSE_EQ|INE018A01030',  // HINDUNILVR
  'NSE_EQ|INE263A01024',  // BAJFINANCE
  'NSE_EQ|INE038A01020',  // WIPRO
  'NSE_EQ|INE028A01039',  // LT
  'NSE_EQ|INE245A01021',  // HCLTECH
  'NSE_EQ|INE117A01022',  // MARUTI
  'NSE_EQ|INE158A01026',  // TATAMOTORS
  'NSE_EQ|INE669E01016',  // ADANIENT
  'NSE_EQ|INE397D01024',  // BHARTIARTL
  'NSE_EQ|INE176B01034',  // POWERGRID
  'NSE_EQ|INE795G01014',  // HDFCLIFE
  'NSE_EQ|INE860A01027',  // NESTLEIND
];

export const FO_INDEX_KEYS = {
  NIFTY:      'NSE_INDEX|Nifty 50',
  BANKNIFTY:  'NSE_INDEX|Nifty Bank',
  FINNIFTY:   'NSE_INDEX|Nifty Fin Service',
  MIDCPNIFTY: 'NSE_INDEX|NIFTY MID SELECT',
};